import { render } from "./Refresh.vue?vue&type=template&id=3de8d703"
import script from "./Refresh.vue?vue&type=script&lang=js"
export * from "./Refresh.vue?vue&type=script&lang=js"
script.render = render

export default script